'use strict';

angular.module('internal.licenses')
    .controller('InternalTriggerCategoryHistoryModal', ['$scope', '$uibModalInstance', 'DataChangeLog', 'trigger_configuration_trigger_id', function ($scope, $uibModalInstance, DataChangeLog, trigger_configuration_trigger_id) {
        DataChangeLog.getTriggerConfigurationLog({ trigger_configuration_id: null, trigger_configuration_trigger_id: trigger_configuration_trigger_id }).then(function (dataChangeLog) {
            $scope.dataChangeLog = dataChangeLog;
            $scope.loading = false;
        });

        $scope.columns = [
            {
                label: 'Change Date',
                field: 'created_on',
                type: 'datetime'
            },
            {
                label: 'Modified By',
                field: 'created_by'
            },
            {
                label: 'Old Values',
                field: 'old_values',
                type: 'ckeditor'
            },
            {
                label: 'New Values',
                field: 'new_values',
                type: 'ckeditor'
            }
        ];

        $scope.filters = [
            {
                name: 'Date',
                field: 'created_on',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ];


        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;